import styled from 'styled-components';
import { Button } from './button';

export const LinkButton = styled(Button).attrs({
  size: 'small',
  type: 'link',
})`
  font-size: inherit;
  height: auto;
  padding: 0;
`;
